define('Config',['require','marionette'],function (require) {

	var Marionette = require('marionette');

	/**
	 * Returns global config object.
	 */
	var Config = Marionette.Object.extend({

		getOptionOrDefault: function (key, defaultValue) {
			var result = Marionette.Object.prototype.getOption.apply(this, [key]);
			if (_.isUndefined(result)) {
				result = defaultValue;
			}
			return result;
		},

        getBooleanOption: function (key) {
			return (parseInt(this.getOption(key)) === 1);
		},

        setOptions: function (options) {
            _.extend(this.options, options);

            this.triggerMethod('config:changed', this.options);
        },

		isMondayFirstDay: function () {
			return (parseInt(this.getOptionOrDefault('monday_is_first_day')) === 1);
		},

		/**
		 * Returns time format
		 *
		 * @return String
		 */
		getTimeFormat: function () {
			return this.getOptionOrDefault('time_format', '24hr');
		},

		/**
		 * Returns date format
		 *
		 * @return String
		 */
		getDateFormat: function () {
			return this.getOptionOrDefault('date_format', 'Y-m-d');
		},

		/**
		 * Returns timeframe
		 *
		 * @return Integer
		 */
		getTimeFrame: function () {
			return parseInt(this.getOptionOrDefault('time_frame', 5));
		},

		/**
		 * Returns timeline type
		 *
		 * @return String
		 */
		getTimelineType: function () {
			return this.getOption('timeline_type');
		},

		getPluginStatus: function (plugin) {
			var plugins = this.getOption('plugins');
			if (plugins[plugin] && parseInt(plugins[plugin].is_active)) {
				return true;
			}
			return false;
		},

		isAllowedBookOverDay: function () {
			if (parseInt(this.getOption('allow_event_day_break'))) {
				return true;
			}
			return false;
		},

		isAllowedBookOverBreaktime: function () {
			if (parseInt(this.getOption('allow_event_breaktime_break'))) {
				return true;
			}
			return false;
		},

		isRtl: function () {
			return this.getOption('is_rtl') === '1';
		},

        /**
		 * This method return true in case session cookies exists,
		 * otherwise we are not able authenticate client and external
		 * link with client session is not allowed
         */
		isExternalLinkWithAuthAllowed: function () {
            var config = Config.getInstance();
            return !config.getOption('_session_id');

		},

		sbPayInvoicesEnabled: function () {
			return !!this.getOption('sbpay_invoices_enabled');
		}

	});

    /**
     * Static methods and constants
     */
    _.extend(Config, {

        TIMELINE_SLOTS: 'modern',
        TIMELINE_SLOTS_WEEKLY: 'modern_week',
        TIMELINE_FLEXIBLE: 'flexible',
        TIMELINE_FLEXIBLE_WEEKLY: 'flexible_week',
        TIMELINE_CLASSES: 'classes',
        TIMELINE_CLASSES_PLUGIN: 'classes_plugin',
        TIMELINE_EVENT: 'event',
        TIMELINE_FLEXIBLE_PROVIDER: 'flexible_provider',
        TIMELINE_GRID_WEEKLY: 'grid_week',

        _instance: null,

        getInstance: function () {
            if (!Config._instance) {
                var options = {};
                if (!_.isUndefined(config)) {
                    options = config;
                }
                Config._instance = new Config(options);
                
                //TODO store this values somewhere?
                Config._instance.MAX_FILE_SIZE = 5 * 1024 * 1024;
            }
            return Config._instance;
        },

        isMondayFirstDay: function () {
            return Config.getInstance().isMondayFirstDay();
        },

        getTimeFormat: function () {
            return Config.getInstance().getTimeFormat();
        },

        getDateFormat: function () {
            return Config.getInstance().getDateFormat();
        },

        getTimeFrame: function () {
            return Config.getInstance().getTimeFrame();
        },

        getTimelineType: function () {
            return Config.getInstance().getTimelineType();
        }

    });

	return Config;

});

